module.exports = __webpack_public_path__ + "img/text-logo.f15d0333.png";